export default {
    state: {
        items: [],
        pagination: {},
        isFetchingItems: true,
    },
    mutations: {
        setItems(state, items) {
            state.items = items
        },
        addItem(state, item) {
            state.items.unshift(item)
        },
        removeItem(state, itemId) {
            state.items = state.items.filter(item => item.id !== itemId)
        },
        setPagination(state, pagination) {
            state.pagination = pagination
        },
        setIsFetching(state, isFetching = false) {
            state.isFetchingItems = isFetching;
        },
        updateItem(state, item) {
            const index = state.items.findIndex(item => item.id === item.id)
            Vue.set(state.items, index, item)
        },
    },
    getters: {
        listItems: state => state.items,
        itemPagination: state => state.pagination,
        isFetchingItems: state => state.isFetchingItems,
        findItem: state => id => state.items.find(item => item.id === id)
    },
    actions: {
        loadItems(context, params) {
            context.commit('setIsFetching', true);

            window.axios.get('/api/items', { params })
                .then(({ data }) => {
                    context.commit('setItems', data.data)
                    context.commit('setPagination', data.meta)
                    context.commit('setIsFetching', false);
                })
                .catch(error => {
                    console.error(error)
                    context.commit('setIsFetching', true);
                });
        },
        updateItem(context, payload) {
            context.commit('updateItem', payload)
        },
        addItem(context, payload) {
            context.commit('addItem', payload)
        },
        removeItem(context, itemId) {
            context.commit('removeItem', itemId)
        },
        startLoadingItems({ commit }) {
            commit('setIsFetching', true);
        },
    }
}
